import { render } from "./TitleBar.vue?vue&type=template&id=f5c360d0&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"

import "./TitleBar.vue?vue&type=style&index=0&id=f5c360d0&lang=less&scoped=true"

import exportComponent from "D:\\Web-Study\\01-study\\demo\\01-技术\\05-Vue\\Vue3\\01-学习过程&笔记\\项目\\01-作品集介绍页\\01-项目\\work_collection\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c360d0"]])

export default __exports__